import { render, staticRenderFns } from "./MinigamesDropdownFilter.vue?vue&type=template&id=2b592fb3&scoped=true"
import script from "./MinigamesDropdownFilter.vue?vue&type=script&lang=js"
export * from "./MinigamesDropdownFilter.vue?vue&type=script&lang=js"
import style0 from "./MinigamesDropdownFilter.vue?vue&type=style&index=0&id=2b592fb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b592fb3",
  null
  
)

export default component.exports